import React from 'react'
import { Button, Checkbox, Chip, FormControlLabel, Grid, IconButton, InputAdornment, Paper, TextField, Tooltip } from '@material-ui/core'
import { Add as AddIcon, CheckCircle as CheckCircleIcon } from '@material-ui/icons'
import useFileDropZone from '../../../shared/components/DropZone'
import { blue, yellow } from '@material-ui/core/colors'
import ItemModel from '../../items/model/item'
import { useDispatch } from 'react-redux'
import { UpdateItem } from '../../../redux/actions/item/ItemAction'
import { UPDATE_CORRECT_ITEM } from '../../../redux/ActionType/ActionType'
import useNotificationDialog from '../../../shared/components/useNotificationDialog'
import { Alert } from '@material-ui/lab'

const FirstItem = ({selection, handleSelection, Item=new ItemModel(), wipeSelectionItem}) => {

    const [files, setFiles] = React.useState([])

    const [openNotif, setOpenNotif] = React.useState({notif : '', open : false})

    const actionDispatch = useDispatch()

    const [item, setItem] = React.useState(null)

    const handleFile=(f)=>{
        setFiles([...files, ...f])
    }

    React.useEffect(()=>{
       setItem(Item)
    },[Item, Item.id])

    const  {DropZone, handleDropZoneOpen} = useFileDropZone({handleFile : handleFile})

    const { ShowNotificationDialog, handleClose, handleOpen, open}  = useNotificationDialog()


    const handleDeleteOneFile=(i)=>{
        files.splice(i, 1)
        setFiles([...files]);
    }

    React.useEffect(()=>{
        if(openNotif.open){
            setInterval(() => {
                setOpenNotif({notif :'', open : false})
            }, 2000);
        }
    },[openNotif.open])



    const handlePasteCopy=async()=>{
        let text = await navigator.clipboard.readText()
        if(text.toString().trim().length === 0){
            setOpenNotif({notif : 'rien à copier', open  : true})
            return '';
        }

        return text;
    }


    const handleChange=(event)=>{
        setItem({...item, [event.target.name] : event.target.value})
    }

    const handleUpdateCorrectItem=()=>{
        const callback =()=>{
            actionDispatch({type: UPDATE_CORRECT_ITEM.SUCCESS, updateItem  : item})
            wipeSelectionItem()
        }
        const file = files.length > 0 ? files[0] : null
        try {
            actionDispatch(UpdateItem(item, callback, file))
        } catch (error) {
            console.log(error)
        }finally{
            handleClose()
        }
    }


    return (
        <Paper  elevation={4} onClick={()=> handleSelection(1)}

            style={{padding:10 , border:selection=== 1 && `3px solid ${blue[200]}` }}  >
            <form>
                <Grid container spacing={1}>
                <Grid container item xs={12} sm={12} justify="center">
                        <Button size="small" color="primary" variant="contained"> To Update </Button>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <TextField margin='dense'
                            name="Name" label="Nom du Produit" fullWidth onChange={handleChange}
                            variant="outlined" value={item?.Name} InputLabelProps={{shrink : true}}
                            InputProps={{
                                endAdornment : <InputAdornment position="end" >
                                <Tooltip title="paste" placement="left-start">
                                    <IconButton size="small" onClick={async()=>{
                                            let text = await handlePasteCopy()
                                            if(text){
                                                setItem({Name : text})
                                            }
                                        }}>
                                        <CheckCircleIcon fontSize="small"  />
                                    </IconButton>
                                </Tooltip>
                                </InputAdornment>
                            }} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField margin='dense' label="Code barre" fullWidth
                             InputLabelProps={{shrink : true}} name="Barcode"
                             value={item?.Barcode}
                            variant="outlined" onChange={handleChange}
                            InputProps={{
                                endAdornment : <InputAdornment position="end" >
                                <Tooltip title="paste" placement="left-start">
                                    <IconButton size="small" onClick={async()=>{
                                            let text = await handlePasteCopy()
                                            if(text){
                                                setItem({Barcode : text})
                                            }
                                        }}>
                                        <CheckCircleIcon fontSize="small"  /> </IconButton>
                                </Tooltip>
                                </InputAdornment>
                            }} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField margin='dense' label="Prosoft Id" fullWidth
                            value={item?.InternalId} name="InternalId"  onChange={handleChange}
                            variant="outlined"  InputLabelProps={{shrink : true}}
                            InputProps={{
                                endAdornment : <InputAdornment position="end" >
                                <Tooltip title="paste" placement="left-start">
                                <IconButton size="small" onClick={async()=>{
                                        let text = await handlePasteCopy()
                                        if(text){
                                            setItem({InternalId : text})
                                        }
                                    }}>
                                    <CheckCircleIcon fontSize="small"  /> </IconButton>
                                </Tooltip>
                                </InputAdornment>
                            }} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField margin='dense' label="Lien de l'image" fullWidth
                            variant="outlined" value={item?.ImageUrl} name="ImageUrl"
                            onChange={handleChange}  InputLabelProps={{shrink : true}}
                            InputProps={{
                                endAdornment : <InputAdornment position="end" >
                                <Tooltip title="paste" placement="left-start">
                                <IconButton size="small" onClick={async()=>{
                                        let text = await handlePasteCopy()
                                        if(text){
                                            setItem({ImageUrl : text})
                                        }
                                    }}>
                                    <CheckCircleIcon fontSize="small"  /> </IconButton>
                                </Tooltip>
                                </InputAdornment>
                            }}  />
                    </Grid>

                    <Grid item xs={12} sm={2} style={{marginTop:5}}>
                            <FormControlLabel label="Pack"  control={<Checkbox value={item?.HasChilds} checked={item?.HasChilds} name="HasChilds"
                                 onChange={(e)=> setItem({...item, HasChilds : e.currentTarget.checked})} color="primary"  />} />
                    </Grid>

                    <Grid item xs={12} sm={3} style={{marginTop:5}}>
                            <FormControlLabel label="validé"
                                control={<Checkbox value={item?.IsProductValidated} checked={item?.IsProductValidated} name="IsProductValidated"
                                 onChange={(e)=> setItem({...item, IsProductValidated : e.currentTarget.checked})} color="secondary"  />} />
                    </Grid>

                    <Grid container spacing={3}>
                        <DropZone />
                        {files.map((file, idx)=>(
                            <div>
                                <Grid item> <Chip label={file.name} onDelete={()=> handleDeleteOneFile(idx)}  color="primary" /> </Grid>
                            </div>
                        ))}

                       {item?.ImageUrl && <Grid item> <img src={item?.ImageUrl} alt="" height={120} width={120} /> </Grid>}

                      {files.length < 1 &&
                       <Grid item style={{height:50, width:50, backgroundColor: yellow[100],  padding:0, margin:20}}>
                            <IconButton onClick={handleDropZoneOpen}> <AddIcon /> </IconButton>
                       </Grid>}
                    </Grid>

                    <Grid container spacing={3} justify="flex-end">
                        {open && <ShowNotificationDialog title="Mise à jour" action={
                            <React.Fragment>
                               <Grid container justify="space-between" >
                                    <Grid item xs={3} sm={3}> <Button color="primary" onClick={handleClose}> Annuler </Button> </Grid>
                                    <Grid item xs={3} sm={3}> <Button color="secondary" onClick={handleUpdateCorrectItem} size="small"> mettre à jour </Button> </Grid>
                                </Grid>
                            </React.Fragment>
                        }>
                            <Alert severity="info"> Vous êtes sur le point de mettre à jour ce produit, continuer ? </Alert>
                        </ShowNotificationDialog>}
                           <Grid item>
                                <Button disabled={!item?.id} variant="contained" color="primary" onClick={handleOpen}> save </Button>
                           </Grid>
                    </Grid>
                </Grid>
            </form>
        </Paper>
    )
}

export default FirstItem
